<template>
  <div
    class="content content-h"
    :data-footer="fs ? 'show' : 'hide'"
    id="imbeeWidget"
  ></div>
</template>

<script>
export default {
  name: "Content",
  props: {
    fs: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  border: 0px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
}

.content-h[data-footer="show"] {
  height: calc(100% - 91px);
}
.content-h[data-footer="hide"] {
  height: calc(100% - 60px);
}
</style>


// WEBPACK FOOTER //
// Content.vue?2ca61b28